<template>
  <button
    class="custom-button"
    :class="[customClass, variant, { disabled: disabled, 'with-icon': icon }]"
    @click="onButtonClick($event)">
    {{ title }}
    <img v-if="icon" class="icon" :src="`assets/images/icons/${icon}.svg`" />
  </button>
</template>

<script>
export default {
  name: "CustomButton",
  props: {
    variant: { type: String, default: "" },
    customClass: { type: String, default: "" },
    title: { type: String, default: "" },
    disabled: { type: Boolean, default: false },
    icon: { type: String, default: "" },
  },
  methods: {
    onButtonClick(e) {
      if (!this.disabled) {
        this.$emit("onClick", e);
      }
    },
  },
};
</script>

<style  lang="scss">
@import "@/styles/imports";

.custom-button {
  display: flex;
  flex: 1;
  padding: 8px;
  background: var(--primary-button-color);
  color: var(--white);
  border-radius: 4px;
  justify-content: center;
  font-size: 14px;
  font-family: "Maersk Headline";
  cursor: pointer;
  border: none;
  &.default {
    background: var(--default-button-color);
    color: var(--primary-text);
  }
  &.disabled {
    cursor: not-allowed;
  }

  .icon {
    margin: 3px 0 0 8px;
  }
}
</style>